// removed by extract-text-webpack-plugin
module.exports = {"label":"FormLabel__label___2vGVB","label--inline":"FormLabel__label--inline___3yucW","label--large":"FormLabel__label--large___3m_H-","label--error":"FormLabel__label--error___1VHnp","title":"FormLabel__title___kJR1X","sub-label":"FormLabel__sub-label___1ud2W","title-buttons":"FormLabel__title-buttons___1FndQ","content":"FormLabel__content___3-fdk","error":"FormLabel__error___1PTNY","note":"FormLabel__note___3m1Qv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Label/FormLabel.scss
// module id = 516
// module chunks = 1